<div class="d-flex flex-column">
    <p-progressbar [value]="progressValue" class="d-block mr-0"
                   [showValue]="showValue" [mode]="mode">
    </p-progressbar>

    @if (currentMessageIndex >= 0) {
        <div class="align-self-center d-flex">
            <span>{{ messages[currentMessageIndex] }}</span>
        </div>
    }

</div>
